




import { Component, Vue } from 'vue-property-decorator';

import flagKeys from '@/constants/flagKeys';

import ManagerV1 from './v1/Manager.vue';
import ManagerV2 from './v2/Manager.vue';

@Component({
  components: {
    ManagerV1,
    ManagerV2
  }
})
export default class ManagerPage extends Vue {
  flags = this.$store.getters['flags/getFlags'] || [];

  get withoutMerchantInterface() {
    return this.flags.includes(flagKeys.withoutMerchantInterface);
  }

  get pageComponent() {
    return this.withoutMerchantInterface ? 'ManagerV2' : 'ManagerV1';
  }
}
